module.exports = __webpack_public_path__ + "media/images/ohap_courses_off-7696c1b03f3c910e9936e8605b8b5744.png";